export const LOGO_URL = "/logo.png";

export function Logo({ size = 40, className = "" }) {
  return (
    <img
      src={LOGO_URL}
      alt="Villa Mana"
      data-testid="brand-logo"
      style={{ height: `${size}px` }}
      className={`w-auto object-contain ${className}`}
    />
  );
}

export function Wordmark({ className = "" }) {
  return (
    <span className={`font-display tracking-[0.18em] uppercase ${className}`}>
      Villa&nbsp;Mana
    </span>
  );
}

